export default __webpack_public_path__ + "img/8da82b54d56a46d26674b064d9affa16.svg";